export default {
  'completeprofile.completeprofile': 'بدء عملية استكمال الملف الشخصي',
  'completeprofile.maintext':
    'لإكمال عناصر ملفك الشخصي والحصول على نقاط إيجابية، يرجى محاولة استكمال ملفك الشخصي عن طريق الضغط على استكمال الملف الشخصي',
};
